import { createContext, useContext } from "react";

import { GroupFragment } from "@/generated/graphql";

import { ProjectIssuesTable } from "../../hooks/use-project-issues-table";

/** Context value for the project management table */
export interface ProjectManagementTableContextValue {
  /** Table of project issues */
  table: ProjectIssuesTable;

  group: GroupFragment;

  isShowTasksOnly: boolean;

  assessmentDueDate: Date;
}

const defaultValue: ProjectManagementTableContextValue = {
  table: {} as ProjectIssuesTable,
  group: {} as GroupFragment,
  isShowTasksOnly: false,
  assessmentDueDate: new Date(),
};

/** Context for the project management table */
export const ProjectManagementTableContext =
  createContext<ProjectManagementTableContextValue>(defaultValue);

/** Hook to access the project management table context */
export const useProjectManagementTableContext = () =>
  useContext(ProjectManagementTableContext);
